// src/modules/app-views/_apps/appmulti/operators/pages/Init/components/tableColumns/exchangeRateColumn.js
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { Tooltip } from 'antd';
import { ThunderboltOutlined } from '@ant-design/icons';
import translateX from 'utils/translateX';
import operatorsService from 'modules/app-views/_apps/appmulti/operators/service';
import financialService from 'services/financialService';
import { parseDateToDisplay } from 'utils/helpers';

// *******************************************************************************
// COLUMN FUNCTION
// *******************************************************************************
function exchangeRateColumn(buildColumnProps, options = {}) {
  const {
    key = 'exchangeRate',
    title = 'exchange_rate',
    dataIndex = 'parameters.__exchangeRate',
    width = 160,
    columnProps = { sort: true },
  } = options;

  return {
    key,
    title: translateX(title),
    dataIndex,
    ...(width && { width }),
    ...buildColumnProps(dataIndex, columnProps),
    render: (_, r) => {
      const rate = r?.parameters?.__exchangeRate;
      const currency = r?.parameters?.__exchangeRateSuffix;
      const symbol = operatorsService.getCurrencySymbol(currency);
      const apiEnabled = r?._integrations?.apiEnabled;
      const hasApiRate = !!r?._integrations?.operatorCode && apiEnabled; // Show icon only if API is enabled

      if (!rate) return <span className="text-muted">—</span>;

      const formattedRate = financialService.formatNumber(rate, {
        decimals: 2,
        locale: 'pt-BR',
      });

      // Get last exchange update date
      const exchanges = r?.parameters?.exchanges || [];
      const lastExchange = exchanges.length > 0 ? exchanges[exchanges.length - 1] : null;
      const updateDate = lastExchange?.date || null;

      const tooltipText = updateDate
        ? translateX('updated_at', {
            date: parseDateToDisplay({ date: updateDate, showHours: true }),
          })
        : translateX('api_integration');

      return (
        <div className="d-flex align-items-center" style={{ gap: 6 }}>
          <span className="font-weight-semibold">
            {symbol} {formattedRate}
          </span>
          {hasApiRate && (
            <Tooltip title={tooltipText}>
              <ThunderboltOutlined style={{ color: '#faad14', fontSize: 14 }} />
            </Tooltip>
          )}
        </div>
      );
    },
  };
}

export default exchangeRateColumn;
